import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { convertReferencesToLinks } from '../../helpers/utils';
import { ReactComponent as OpenIcon } from '../../svg/square-link.svg';

interface TypingEffectProps {
  text: string;
  links?: Array<{
    document: string;
    page: number;
    url: string;
  }>;
}

const TypingEffect: React.FC<TypingEffectProps> = ({ text, links }) => {
  const processedText = convertReferencesToLinks(text, links);
  const textWithLineBreaks = processedText.replace(/(?<!\n)\n(?!\n)/g, '  \n');

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ ...props }: { [key: string]: any }) => (
          <div className="link">
            <a {...props} target="_blank" rel="noopener noreferrer">
              {props.children}
            </a>
            <OpenIcon width={14} height={14} />
          </div>
        ),
      }}
    >
      {textWithLineBreaks}
    </ReactMarkdown>
  );
};

export default TypingEffect;
